module.exports = __webpack_public_path__ + "static/img/img_p1_3_phone.9ab77da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_p1_3_phone.png
// module id = bedV
// module chunks = 1